var inputs = {
    continentSelects: document.querySelectorAll(".js-continent-select"),
    countryCheckBoxes: document.querySelectorAll(".js-country-checkbox"),
    init: function () {
        const textInputs = document.querySelectorAll('input[type=text], input[type=email], input[type=tel], input[type=password], input[type=date], input[type=number], textarea');
        if (textInputs) {
            for (let input of textInputs) {
                input.addEventListener('change', function () {
                    this.setAttribute('value', this.value);
                });
                input.setAttribute('value', input.value);
            }
        }

        const buttons = document.querySelectorAll('input[type=submit], a');
        if (buttons) {
            // prevents focus style on click
            buttons.forEach(el => el.addEventListener("mousedown", function (event) {
                event.preventDefault();
            }));
        }

        document.addEventListener("mousedown", function(event) {
            // prevents focus style on click
            if(event.target.tagName.toLowerCase() === 'button') {
                event.preventDefault();
            }
        })

        const showPasswords = document.querySelectorAll(".js-show-password");
        if (showPasswords) {
            showPasswords.forEach(el => el.addEventListener("click", function () {
                const input = el.previousElementSibling;
                if (input && input.type === "password") {
                    input.type = "text";
                } else if (input) {
                    input.type = "password";
                }
                // Placing cursor at the end of input
                setTimeout(function(){ input.selectionStart = input.selectionEnd = 10000; }, 0);
            }));
        }

        const multiRangeSliders = document.querySelectorAll(".double-range-slider");
        if (multiRangeSliders) {
            for (let slider of multiRangeSliders) {
                const sliderInputs = slider.querySelectorAll("input[type=range]");
                sliderInputs.forEach(el => el.addEventListener("input", this.updateMultiRangeSlider));
            }
        }


        if (this.continentSelects)
            this.continentSelects.forEach(el => el.addEventListener("click", this.showCountries));

        if (this.countryCheckBoxes) {
            for (let countryCheckbox of this.countryCheckBoxes) {
                let checkbox = countryCheckbox.querySelector('input')
                checkbox.addEventListener("click", this.selectCountry);
                //TODO: Fix this mess...
                if (checkbox.checked) {
                    const countryDropdown = checkbox.closest(".js-country-dropdown");
                    const countryDropdownButton = countryDropdown.querySelector(".country-dropdown__button");
                    countryDropdown.classList.add('selected');
                    let countryTag = document.createElement('span');
                    countryTag.dataset.id = checkbox.id;
                    countryTag.className = 'selected-tag js-selected-tag';
                    countryTag.innerText = checkbox.dataset.value;
                    countryDropdownButton.appendChild(countryTag);
                }
            }
        }
    },
    showCountries: function () {
        inputs.continentSelects.forEach(el => el.classList.remove("active"));
        this.classList.add('active');
        const continentToShow = this.dataset.id;
        if (continentToShow === "All") {
            inputs.countryCheckBoxes.forEach(el => el.style.removeProperty('display'))
        } else {
            const countriesToShow = document.querySelectorAll('[data-continent="' + continentToShow + '"');
            inputs.countryCheckBoxes.forEach(el => el.style.display = 'none');
            countriesToShow.forEach(el => el.style.removeProperty('display'));
        }
    },
    selectCountry: function () {
        const countryDropdown = this.closest(".js-country-dropdown");
        const countryDropdownInput = countryDropdown.querySelector("input[type=hidden]");
        const countryDropdownButton = countryDropdown.querySelector(".country-dropdown__button");
        if (this.checked) {
            countryDropdown.classList.add('selected');
            let countryTag = document.createElement('span');
            countryTag.dataset.id = this.id;
            countryTag.className = 'selected-tag js-selected-tag';
            countryTag.innerText = this.dataset.value;
            countryDropdownButton.appendChild(countryTag);
        } else {
            countryDropdownButton.querySelector('[data-id="' + this.id + '"]').remove();
            if (!countryDropdownButton.querySelectorAll('[data-id]').length)
                countryDropdown.classList.remove('selected');
        }
        const allCountryTags = countryDropdownButton.querySelectorAll('[data-id]');
        let countryTags = [];
        for (let tag of allCountryTags) {
            countryTags.push(tag.textContent);
        }
        countryDropdownInput.value = countryTags.join(', ');
    },
    updateMultiRangeSlider: function () {
        const parent = this.closest(".double-range-slider");
        const ranges = parent.querySelectorAll('input[type=range]');
        let rangeInput = parent.querySelector("input[type=text]");
        let values = [];
        ranges.forEach(el => values.push(el.value));

        let inputValue = numberWithCommas(Math.min(...values)) + "-" + numberWithCommas(Math.max(...values));
        rangeInput.value = inputValue;

        function numberWithCommas(x) {
            if (x < 10000) return x;

            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    }
}

export default inputs;